
<div class="about mt-24 container ">
    <div class="container grid grid-rows-3">
        <div class="center header-title">
            <h1>About</h1>
            <p class="text-bold mt-4">
                I am Amgga and experienced software engineer with a passion for delivering innovative and high-quality solutions. I have a strong background in programming, problem-solving, and project management, and I am always eager to take on new challenges and learn new technologieson

            </p>
            <!-- <div class="icon">
                <img loading="lazy" src="../../../assets/nft/dots.png" width="36" height="12" alt=""/>
            </div> -->
        </div>
    </div>
    <div
        class="banner-image mb-20">
        <!-- {{projectDetail.videoLink}} -->
        <iframe width="560" height="315" src="https://www.youtube.com/embed/X22NmS_LG7Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        <div class="mt-4 text-center text-lg font-bold text-gray-500">
            <p>Just introduce myself</p>
        </div>

    </div>
</div>
